/* eslint-disable no-dupe-keys */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import {useState, useEffect, useRef} from 'react'
import "react-datepicker/dist/react-datepicker.css";
import calendar from '../../assets/calendar.svg'
import makanan1 from '../../assets/makanan1.png'
import eventimg from '../../assets/eventimg.png'
import { useNavigate } from "react-router-dom";
import circleback from '../../assets/circleback.svg'
import down from '../../assets/down.svg'
import user from '../../assets/user.svg'
import plus from '../../assets/plus.svg'
import minus from '../../assets/minus.svg'
import "react-datepicker/dist/react-datepicker.css";
import { PageLogin } from '../LoginPage/PageLogin'
import { CSSTransition } from 'react-transition-group';
import spinner from '../../assets/spinner.gif'
import location from '../../assets/pin.svg'

export const PageSetEventSchedule = () => {
    const [detail,setDetail] = useState()
    const [guest, setGuest] = useState(1)
    const history = useNavigate()
    const [total, setTotal] = useState(0)
    const [showCalendar, setShowCalendar] = useState(false)
    const [selectedDate, setSelectedDate] = useState()
    const [dateShown, setDateShown] = useState('Select date & time')
    const [clockSelected, setClockSelected] = useState('')
    const [showLogin, setShowLogin] = useState(false)
    const [specialRequest, setSpecialRequest] = useState('')
    const [val1, setval1] = useState(false)
    const [loading, setLoading] = useState(true)
    const firstUpdate2 = useRef(true);
    const firstUpdate = useRef(true);
    const firstUpdate5 = useRef(true);
    const [voucher, setVoucher] = useState()
    const [voucherAmount, setVoucherAmount] = useState(0) 
    const [totalAfter, setTotalAfter] = useState()
    const [showNavPopup, setShowNavPopup] = useState(false)

    const handleSelectDate = (e) => {
        setSelectedDate(e[0])
        setClockSelected(e[1])
        var elem = document.getElementById("PSSdateshown");
        elem.className = "tiny normal PSSpertanyaantext black"
        setDateShown(`${e[0]}  |   ${e[1]}`)
        setShowCalendar(false)
    }



    const formatDate = (data) =>{
        if(data<10){
          return `0${data}`
        }else{
          return data
        }
    }

    const handleGuest = (e) => {
        var elem = document.getElementById("PSSguestshown");
        elem.className = "tiny normal PSSpertanyaantext black"
        if(e === "minus"){
            if(guest === 1){
                return
            }else{
                setGuest(guest-1)
            }
        }else{
            if(guest === detail.pricelist[detail.pricelist.length-1].max){
                return
            }else{
                setGuest(guest+1)
            }
        }
    }

    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true)
        setDetail({nama:"Thanksgiving",foto:eventimg, style:"American style featuring Turkey and Sides",fotoMakanan:makanan1,menu:["Beef bulgogi", "Yaki gyoza"],pricelist:[{min:1,max:4,harga:200},{min:5,max:6,harga:150}], jadwal:[{tanggal:"24 Feb 2022",jam:"18:00 - 19:00"},{tanggal:"24 Feb 2022",jam:"19:00 - 20:00"}, {tanggal:"27 Feb 2022",jam:"18:00 - 19:00"}],tempat:"Cilandak Town Square, Jalan Tahi Bonar Simatupang, RT.6/RW.9, West Cilandak, South Jakarta City, Jakarta, Indonesia" })
        localStorage.setItem('nav', 'e')
    },[])

    useEffect(() => {
        if (firstUpdate2.current) {
            firstUpdate2.current = false;
        }else{
            setLoading(false)
            setTotal(detail.pricelist[0].harga*1000)
        }
    },[detail])

    useEffect(() => {
        setTotalAfter(total-voucherAmount)
    },[total])

    useEffect(()=>{
        if (firstUpdate.current) {
            firstUpdate.current = false;
        }else{
            var elem = document.getElementById("PSSdate");
            var elem2 = document.getElementById("PSSdatedown");
            elem2.style.transition = "transform 0.5s"
            if(showCalendar===true){
                elem.className = "PSSpertanyaan flex PSSyellow";
                elem2.style.transform = "rotate(180deg)"
            }else{
                elem.className = "PSSpertanyaan flex";
                elem2.style.transform = "rotate(0)"
            }
        }
    },[showCalendar])

    const handleOpenPopUp = (e) => {
        if(e === "date"){
            setShowCalendar(true)
        }
    }

    const convertToRupiah = (angka) => {
        var rupiah = '';		
        var angkarev = angka.toString().split('').reverse().join('');
        for(var i = 0; i < angkarev.length; i++) if(i%3 === 0) rupiah += angkarev.substr(i,3)+'.';
        return rupiah.split('',rupiah.length-1).reverse().join('');
    }

    useEffect(()=>{
        if (firstUpdate5.current) {
            firstUpdate5.current = false;
        }else{
            for (var x in detail.pricelist){
                if(guest <= detail.pricelist[x].max && guest >= detail.pricelist[x].min){
                    setTotal(detail.pricelist[x].harga * 1000 * guest)
                }
            }
        }
    },[guest])

    const handleSubmit = () => {
        let isError=false
        var elem = document.getElementById("PSSdate");
        if(dateShown === 'Select date & time'){
            elem.className = "PSSpertanyaan flex PSSred";
            isError=true
            setval1(true)
        }else{
            elem.className = "PSSpertanyaan flex";
            setval1(false)
        }

        if(isError){
            return
        }else{
            localStorage.setItem('tanggal',dateShown)
            localStorage.setItem('jam',clockSelected)
            localStorage.setItem('specialRequest', specialRequest)
            localStorage.setItem('pax', guest)
            localStorage.setItem('total',total)
            localStorage.setItem('totalAfter',totalAfter)
            setstandby(false)
        }
    }

    const [standby, setstandby] = useState(true)
    useEffect(()=>{
        
        if(standby===false){
            setTimeout(function() {
                history("/event/detailEvent/setSchedule/submitBooking");
           }, 500);
        }
    },[standby])

    const handleCloseAll = () => {
        setShowCalendar(false)
        setShowNavPopup(false)
    }

    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <img onClick={e => {e.preventDefault();e.stopPropagation();history(-1)}} className='backmobile' alt="back" src={circleback}></img>
            {
                loading?
                <img alt='loading' className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:1000,enter:2000,exit:1000}} mountOnEnter={true} appear={true} classNames="PSStrans">
                <div className='PSScontainer'>
                    <p className='big bold white PSStitle'>Set Schedule</p>
                    <div className='flex PSSmainwrapper'>
                        <div className='PSSkontenkiri'>   
                            <p className='semibig white PSSmargin'>Event</p>
                            <div className='flex' style={{marginTop:"18px"}}>
                                <div className='PSSimg' style={{backgroundImage:`url(${detail.foto})`}}></div>
                                <div className='PSSimg2'>
                                <p className='normal medium white'>{detail.nama}</p>
                                <p className='small grey' style={{marginTop:"4px"}}>{detail.style}</p>
                                </div>
                            </div>

                            <p className="semibig white PSSmargin">Menu</p>
                            <div className='flex' style={{marginTop:"18px"}}>
                                <div className='PSSimg' style={{backgroundImage:`url(${detail.fotoMakanan})`}}></div>
                                <div className='PSSimg2 flex' style={{flexDirection:"column"}}>
                                    <p className='normal medium white'>{
                                            detail.menu.map((post) => {
                                                if(post === detail.menu[0]){
                                                    return(<span>{post}</span>)

                                                }else{
                                                    return(<span>, {post}</span>)
                                                }
                                            })
                                        }</p>
                                </div>
                            </div>

                            <p className="semibig white PSSmargin">Special Request</p>
                            <p className="tiny" style={{color:"#AAAAAA", marginTop:"18px"}}>*Any requests made will be reviewed by the Taplak Partner before confirming the event</p>
                            <textarea value={specialRequest} onChange={e => setSpecialRequest(e.target.value)} className='PSStextarea' rows="10" placeholder="*Any requests made will be reviewed by the Taplak Partner before confirming the event"></textarea>
                        </div>
                        
                        <div className='PSSkontenkanan'>
                            <div className='PSSmargin PSSkananwrapper1'>
                                <div className='PSSformkontainer'>
                                    <p className='medium bold'>Your Booking</p>
                                    <div className='PSSformgroup'>
                                        <div className='PSSpertanyaanflex'>
                                            <p className='small normal PSSpertanyaantext'>Location</p>
                                            <div className='flex' style={{marginTop:"12px"}}>
                                                <img alt='icon' style={{marginTop:"2px"}} src={location} className="PSSiconkiri"></img>
                                                <p className='small'>{detail.tempat}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='PSSformgroup flex'>
                                        <div className='PSSpertanyaanflex'>
                                            <p className='small normal PSSpertanyaantext'>Date & Time</p>
                                            <div onClick={e => {e.preventDefault();e.stopPropagation();showCalendar? setShowCalendar(false):handleOpenPopUp("date")}} id="PSSdate" className='PSSpertanyaan flex'>
                                                <img className='PSSiconkiri' alt='icon' src={calendar}></img>
                                                <p id="PSSdateshown" className='verytiny normal PSSpertanyaantext'>{dateShown}</p>
                                                <img id="PSSdatedown" className='PSSiconkanan' alt='icon' src={down}></img>
                                            </div>
                                        </div>
                                        {
                                        showCalendar === true && (
                                            <div className="PSSpopupkontainer2">
                                                <div style={{postion:"relative", height:"100%", width:"-webkit-fill-available",width: "-moz-available", padding:"25px"}}>
                                                    {
                                                        detail.jadwal.map((post) => (
                                                            <p onClick={e => {e.preventDefault();e.stopPropagation();handleSelectDate([post.tanggal,post.jam])}} className='tiny PSSopsi'>{post.tanggal} &ensp; • &ensp;  {post.jam}</p>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        )
                                        }
                                        
                                    </div>
                                    {
                                        val1 && (
                                            <p className='bold verytiny' style={{color:"#FA591D", marginTop:"8px", marginBottom:"8px", textAlign:"right"}}>Please select the date & time!</p>
                                        )
                                    }

                                    

                                    <div className='PSSformgroup'>
                                        <div className='PSSpertanyaanflex'>
                                            <p className='small normal PSSpertanyaantext'>Guest</p>
                                            <div className='PSSpertanyaan flex'>
                                                <img className='PSSiconkiri' alt='icon' src={user}></img>
                                                <p id="PSSguestshown" className='verytiny normal PSSpertanyaantext'>{guest} guest</p>
                                                <img onClick={e => {e.preventDefault();e.stopPropagation();handleCloseAll();handleGuest("minus")}} className='PSSiconkanan' alt='icon' src={minus}></img>
                                                <img onClick={e => {e.preventDefault();e.stopPropagation();handleCloseAll();handleGuest("plus")}} className='PSSiconkanan' alt='icon' style={{marginLeft:"24px"}} src={plus}></img>
                                            </div>
                                        </div>
                                    </div>

                                    <p className='small SBPmargin grey' style={{marginTop:"26px"}}>Voucher Code</p>
                                    <div className='SBPmargin2 flex'>
                                        <input type='text' value={voucher} onChange={e => setVoucher(e.target.value)} placeholder='Enter voucher code' className='SBPform'></input>
                                        <button className='SBPbutton tiny bold'>Apply</button>
                                    </div>

                                    <p className='PSSpertanyaantext tiny normal' style={{marginTop:"16px"}}>Set menu price(s)</p>
                                    
                                        {
                                            detail.pricelist.map((post) => (
                                                <div className='flex' style={{marginTop:"8px"}}>
                                                    <p className='PSSpertanyaantext tiny bold'>{post.min} - {post.max} guest</p>
                                                    <p className='PSSpertanyaantext tiny bold' style={{marginLeft:"auto"}}>{post.harga}/Pax</p>
                                                </div>
                                            ))
                                        }
                                    <div className='flex' style={{marginTop:"32px"}}>
                                        <p className='small'>Price</p>
                                        <p className='small' style={{marginLeft:"auto"}}>IDR {convertToRupiah(total)}</p>
                                    </div>
                                    <div className='flex' style={{marginTop:"4px"}}>
                                        <p className='small'>Voucher Amount</p>
                                        <p className='small' style={{marginLeft:"auto"}}>-</p>
                                    </div>
                                    <div className='flex' style={{marginTop:"32px"}}>
                                        <p className='small'>Price</p>
                                        <p className='small' style={{marginLeft:"auto"}}>IDR {convertToRupiah(total)}</p>
                                    </div>
                                    
                                </div>
                                {
                                    localStorage.getItem('TaplakLoggedIn')==='true' ?

                                <div className='PSSformkontainer' style={{marginTop:"32px"}}>
                                    <p className='medium bold'>Submit Your Booking</p>
                                    <button onClick={e => {e.preventDefault();e.stopPropagation();handleSubmit()}}  className='PSSbutton bold'>Continue to Submit</button>
                                </div>
                                :
                                <div className='PSSformkontainer' style={{marginTop:"32px"}}>
                                    <p className='medium bold'>Login or register to book</p>
                                    <button onClick={e => {e.preventDefault();e.stopPropagation();setShowLogin(true)}} className='PSSbutton bold'>Login/Register</button>
                                </div>
                                }
                            </div>
                            

                            
                        </div>
                    </div>
                </div>
                </CSSTransition>
            }
            {
                showLogin && (
                <PageLogin fungsi={() => setShowLogin(false)}></PageLogin>
                )
            }
            
        </div>
    )
  }